import React from 'react'

// MUI Components
import { 
    Menu, 
    MenuItem, 
    Box, 
    Typography 
} from '@mui/material'

// MUI Icons
import DeleteIcon from '@mui/icons-material/Delete'
import DriveFileRenameOutlineIcon from '@mui/icons-material/DriveFileRenameOutline';
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import ShareIcon from '@mui/icons-material/Share'
import HistoryIcon from '@mui/icons-material/History'

const OptionsMenu = ({ anchorEl, open, onClose, onDelete, onDuplicate, onShare, onSeeHistory, onRename }) => {
    // Define all possible menu items
    const allMenuItems = [
        {
            icon: <ContentCopyIcon sx={{ fontSize: 18 }} />,
            label: 'Duplicate',
            onClick: onDuplicate,
            color: '#374151',
            show: !!onDuplicate
        },
        {
            icon: <ShareIcon sx={{ fontSize: 18 }} />,
            label: 'Share',
            onClick: onShare,
            color: '#374151',
            show: !!onShare
        },
        {
            icon: <HistoryIcon sx={{ fontSize: 18 }} />,
            label: 'See history',
            onClick: onSeeHistory,
            color: '#374151',
            show: !!onSeeHistory
        },
        {
            icon: <DriveFileRenameOutlineIcon sx={{ fontSize: 18 }} />,
            label: 'Rename',
            onClick: onRename,
            color: '#374151',
            show: !!onRename
        },
        {
            icon: <DeleteIcon sx={{ fontSize: 18 }} />,
            label: 'Delete',
            onClick: onDelete,
            color: '#DC2626',
            show: !!onDelete
        }
    ]

    // Filter to only show items where the handler is provided
    const menuItems = allMenuItems.filter(item => item.show)

    return (
        <Menu
            anchorEl={anchorEl}
            open={open}
            onClose={onClose}
            transformOrigin={{ horizontal: 'right', vertical: 'top' }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            PaperProps={{
                sx: {
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)',
                    borderRadius: '6px',
                    minWidth: '180px',
                    mt: 0.5
                }
            }}
        >
            {menuItems.map((item, index) => (
                <MenuItem
                    key={index}
                    onClick={() => {
                        item.onClick && item.onClick()
                        onClose()
                    }}
                    sx={{
                        color: item.color,
                        py: 1.5,
                        px: 2,
                        fontSize: '14px',
                        '&:hover': {
                            backgroundColor: '#F3F4F6'
                        }
                    }}
                >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                        {item.icon}
                        <Typography variant="body2" sx={{ fontSize: 'inherit', color: 'inherit' }}>
                            {item.label}
                        </Typography>
                    </Box>
                </MenuItem>
            ))}
        </Menu>
    )
}

export default OptionsMenu